import { AddRounded, EditRounded } from "@mui/icons-material";
import { Box, Button, Divider, IconButton, Stack, Typography } from "@mui/material";
import { allStylesPath, attrGrpTableStrColumnsObj } from "components/PimDashboard/data";
import { fileColumns, modalProfileFileAssocObj, modalProfileImagesAssocObj, modalProfileUrlKey } from "../CreateModalProfile/data";
import { AuthState } from "context/AuthContext";
import { getRelProtectedFileSignedUrl } from "data/globalData";
import { useEffect, useState } from "react";
import axios from "axios";
import ImageSlider from "components/PimDashboard/CommonComponents/ImageSlider/ImageSlider";
import AddNewImageModal from "./AddNewImageModal/AddNewImageModal";
import { GlobalState } from "context/GlobalContext";
import { useNavigate, useSearchParams } from "react-router-dom";
import { styleImgDepartmentCol } from "components/PimDashboard/DashboardComponents/Designer/CreateStyle/data";

import DisplayDetailsWithEditTab from "./DisplayDetailsWithEditTab/DisplayDetailsWithEditTab";
import EditImageDataModal from "./EditImageDataModal/EditImageDataModal";
import { parseErrorMessage } from "utils/ErrorFunctions/parseErrorMessage";
import { custom, departments } from "data/authData";
import AddFiles, { fileColumn } from "components/PimDashboard/CommonComponents/AddFiles/AddFiles";
import { studioAttrGrpAttrAssocObj } from "../StudioAttributes/data";
import { StudioDashboardState } from "context/StudioDashboardContext";
import { studioAttrGroupLinkedTables } from "../StudioAttributeGroups/data";
const imgWidth = 190;
const imgHeight = 240;

const SelectedModalProfile = () => {
	const { user } = AuthState();
	const { setSnackBar, setSnackBarOpen, snackBar, setLoadingOpen, Loadingopen } = GlobalState();
	const { selectedModalProfile, setSelectedModalProfile, attrGroupsWithAttr } = StudioDashboardState();
	let [searchParams, setSearchParams] = useSearchParams();

	const disableEdit = user?.role?.[custom.MODAL_PROFILE_VIEWER.key] === true;
	useEffect(() => {
		const fetch = async () => {
			setLoadingOpen(true);
			setSelectedModalProfile();
			try {
				const res = await axios.get(`/api/studio/modal_profile_by_id/${modalProfileId}`);
				setSelectedModalProfile(res.data);
				setLoadingOpen(false);
			} catch (error) {
				setSnackBarOpen(true);
				setSnackBar({ ...snackBar, message: parseErrorMessage(error) });
				setLoadingOpen(false);
			}
		};
		let modalProfileId = searchParams.get(modalProfileUrlKey);
		if (modalProfileId && modalProfileId !== selectedModalProfile?.id) fetch();
		else {
			setSelectedModalProfile(null);
		}
	}, [searchParams]);

	const navigate = useNavigate();

	const [addNewImgModal, setAddNewImgModal] = useState(false);
	const [imgInfoModal, setImgInfoModal] = useState(false);

	const handleImagesUpload = async (files, data) => {
		const formData = new FormData();
		for (let i = 0; i < files.length; i++) {
			formData.append(modalProfileImagesAssocObj, files[i].file);
		}
		formData.append("modal_profile_id", data?.[studioAttrGroupLinkedTables.modal_profile.key]?.modal_profile_id);
		return await axios
			.post("/api/studio/upload_modal_profile_images", formData, {
				headers: {
					"content-type": "multipart/form-data",
				},
			})
			.then((res) => {
				return res.data.result;
			})
			.catch((err) => {
				return parseErrorMessage(err);
			});
	};
	const handleFileAdd = async (newFileData) => {
		const formData = new FormData();
		formData.append("file", newFileData[fileColumn.key]);
		formData.append("fileMeta", JSON.stringify(newFileData));

		const uploadToBucket = await axios.post("/api/upload/single_upload_to_rel_bucket", formData, {
			headers: { "Content-Type": "multipart/form-data" },
		});

		const res = await axios.post("/api/studio/create_modal_profile_file_sql", {
			...uploadToBucket.data.result,
			modal_profile_id: selectedModalProfile[studioAttrGroupLinkedTables.modal_profile.key].modal_profile_id,
		});
		setSelectedModalProfile((prev) => ({
			...prev,
			[studioAttrGroupLinkedTables?.modal_profile.key]: {
				...prev?.[studioAttrGroupLinkedTables.modal_profile.key],
				[modalProfileFileAssocObj]: [
					...prev?.[studioAttrGroupLinkedTables.modal_profile.key][modalProfileFileAssocObj],
					res.data.result,
				],
			},
		}));
		return true;
	};
	const handleFileDelete = async (newFileData) => {
		const formData = new FormData();
		formData.append("file", newFileData[fileColumn.key]);
		formData.append("fileMeta", newFileData);
		setLoadingOpen(true);
		try {
			const res = await axios.delete(`/api/studio/delete_modal_profile_file_sql/${newFileData.id}`);
			if (res) {
				setSelectedModalProfile((prev) => ({
					...prev,
					[studioAttrGroupLinkedTables?.modal_profile.key]: {
						...prev?.[studioAttrGroupLinkedTables.modal_profile.key],
						[modalProfileFileAssocObj]: prev?.[studioAttrGroupLinkedTables.modal_profile.key][
							modalProfileFileAssocObj
						]?.filter((row) => row?.id != newFileData.id),
					},
				}));
				setLoadingOpen(false);
				return true;
			}
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({ ...snackBar, message: parseErrorMessage(error) });
			setLoadingOpen(false);
			return false;
		}
		return true;
	};

	const handleFileDownload = async (row) => {
		{
			try {
				setLoadingOpen(true);
				const fileUrl = await getRelProtectedFileSignedUrl(row?.url);
				if (fileUrl) {
					window.open(fileUrl, "_blank");
					setSnackBarOpen(true);
					setSnackBar({ ...snackBar, message: "File Downloaded Successfully", severity: "success" });
					setLoadingOpen(false);
				}
			} catch (error) {
				setSnackBarOpen(true);
				setSnackBar({ ...snackBar, message: parseErrorMessage(error), severity: "error" });
				setLoadingOpen(false);
			}
		}
	};
	const updateMainImage = async (data) => {
		setLoadingOpen(true);
		try {
			const res = await axios.put("/api/studio/change_modal_profile_main_img", data);
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: "Main Image Changed Sucessfully",
				severity: "success",
				anchorOrigin: { horizontal: "center", vertical: "top" },
				res,
			});
			if (res)
				setSelectedModalProfile({
					...selectedModalProfile,
					[studioAttrGroupLinkedTables.modal_profile.key]: {
						...selectedModalProfile[studioAttrGroupLinkedTables.modal_profile.key],
						[modalProfileImagesAssocObj]: selectedModalProfile[studioAttrGroupLinkedTables.modal_profile.key][
							modalProfileImagesAssocObj
						]?.map((row) => {
							if (row.id === data.id) return { ...row, is_main: true };
							else return { ...row, is_main: false };
						}),
					},
				});
			setLoadingOpen(false);
			setImgInfoModal(false);
			return true;
		} catch (error) {
			console.log(error);
			setLoadingOpen(false);

			setSnackBarOpen(true);
			setSnackBar({ ...snackBar, message: parseErrorMessage(error) });
			return false;
		}
	};
	const addNewImages = async (images, mainImgIndex) => {
		setLoadingOpen(true);

		const imageUrls = await handleImagesUpload(images, selectedModalProfile);

		const productImages = imageUrls.map((row, index) => {
			return {
				modal_profile_id: selectedModalProfile?.[studioAttrGroupLinkedTables.modal_profile.key]?.modal_profile_id,
				is_main: false,
				url: row.publicUrl,
			};
		});

		try {
			const res = await axios.post("/api/studio/bulk_create_modal_profile_img_sql", productImages);

			setSelectedModalProfile({
				...selectedModalProfile,
				[studioAttrGroupLinkedTables.modal_profile.key]: {
					...selectedModalProfile[studioAttrGroupLinkedTables.modal_profile.key],
					[modalProfileImagesAssocObj]: [
						...selectedModalProfile[studioAttrGroupLinkedTables.modal_profile.key][modalProfileImagesAssocObj],
						...res.data.result,
					],
				},
			});
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: "Images created Successfully",
				severity: "success",
				anchorOrigin: { horizontal: "center", vertical: "top" },
				res,
			});
			setLoadingOpen(false);

			return true;
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({ ...snackBar, message: parseErrorMessage(error) });
			setLoadingOpen(false);
			return false;
		}
	};

	const goToProfilesPage = () => {
		navigate(allStylesPath);
	};

	const updateDetailsFun = async (data, modelCloseFun, attrGrp) => {
		if (data) {
			try {
				const res = await axios.put(
					`/api/studio/update_modal_profile_data/${attrGrp?.linked_table}?group_id=${attrGrp?.group_id}`,
					data
				);

				setSelectedModalProfile({
					...selectedModalProfile,
					[attrGrp.linked_table]: data,
					res,
				});
				setSnackBarOpen(true);
				setSnackBar({
					...snackBar,
					message: "Data saved successfully",
					severity: "success",
					anchorOrigin: { horizontal: "center", vertical: "top" },
					res,
				});
				modelCloseFun();
			} catch (error) {
				console.log(error, "hgfghrdfdggggggghjk");
				setSnackBarOpen(true);
				setSnackBar({ ...snackBar, message: parseErrorMessage(error) });
			}
		}
	};

	if (selectedModalProfile)
		return (
			<Box width="100%" display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap">
				<Divider orientation="horizontal" flexItem sx={{ width: "100%", mt: 1, mb: 1 }} />
				{/* top section */}
				<Box display="flex" justifyContent="space-around" width="100%">
					{/* left */}
					<Box>
						<Box width={imgWidth} height={imgHeight}>
							<ImageSlider
								imgWidth={imgWidth}
								imgHeight={imgHeight}
								column="url"
								images={
									selectedModalProfile?.[studioAttrGroupLinkedTables.modal_profile.key]?.[modalProfileImagesAssocObj]
										?.length
										? selectedModalProfile?.[studioAttrGroupLinkedTables.modal_profile.key]?.[
												modalProfileImagesAssocObj
										  ]
										: []
								}
							/>
						</Box>
						{console.log(selectedModalProfile, "dsfsdvbn")}
						<Box p={1} display="flex" columnGap={2}>
							<IconButton
								disabled={disableEdit}
								startIcon={<EditRounded sx={{ color: "#fff" }} />}
								sx={{
									background: "#000",
									"&: hover": { background: "#00000083" },
									// width: 100,
								}}
								variant="contained"
								onClick={() => setImgInfoModal(true)}>
								<EditRounded sx={{ color: "white" }} />
							</IconButton>
							<IconButton
								disabled={disableEdit}
								sx={{
									background: "#000",
									"&: hover": { background: "#00000083" },
								}}
								variant="contained"
								onClick={() => setAddNewImgModal(true)}>
								<AddRounded sx={{ color: "#fff" }} />
							</IconButton>
						</Box>
					</Box>
					<Divider orientation="vertical" flexItem />
					{/* right */}
					<Box sx={{ width: "76%" }}>
						{Object.keys(attrGroupsWithAttr)
							.reduce((acc, row) => {
								if (
									attrGroupsWithAttr[row][attrGrpTableStrColumnsObj.linked_table.key] ===
									studioAttrGroupLinkedTables.modal_profile.key
								)
									acc.push(attrGroupsWithAttr[row]);
								return acc;
							}, [])
							?.map((row) => {
								return (
									<DisplayDetailsWithEditTab
										columns={[...row[studioAttrGrpAttrAssocObj]]}
										data={selectedModalProfile}
										setData={setSelectedModalProfile}
										attrGrp={row}
										disableEdit={true}
										updateFunction={updateDetailsFun}
										width="30%"
									/>
								);
							})}
					</Box>
				</Box>
				<Divider orientation="horizontal" flexItem sx={{ width: "100%", mt: 1 }} />

				{/* style Details Table Columns */}
				{Object.keys(attrGroupsWithAttr)
					.reduce((acc, row) => {
						if (
							attrGroupsWithAttr[row][attrGrpTableStrColumnsObj.linked_table.key] ===
							studioAttrGroupLinkedTables.modal_profile_details.key
						)
							acc.push(attrGroupsWithAttr[row]);
						return acc;
					}, [])
					?.map((row) => {
						return (
							<DisplayDetailsWithEditTab
								columns={[...row[studioAttrGrpAttrAssocObj]]}
								data={selectedModalProfile}
								setData={setSelectedModalProfile}
								attrGrp={row}
								updateFunction={updateDetailsFun}
								disableEdit={disableEdit}
							/>
						);
					})}

				<Divider sx={{ width: "100%", mt: 2, mb: 1 }} orientation="horizontal" />
				<AddFiles
					addNewDefault={{ [styleImgDepartmentCol.key]: departments.STUDIO.key }}
					columns={fileColumns}
					handleAddFile={handleFileAdd}
					files={selectedModalProfile?.[studioAttrGroupLinkedTables.modal_profile.key]?.[modalProfileFileAssocObj] ?? []}
					setFiles={(files) => {
						setSelectedModalProfile((prev) => ({
							...prev,
							[studioAttrGroupLinkedTables?.modal_profile.key]: {
								...prev?.[studioAttrGroupLinkedTables.modal_profile.key],
								[modalProfileFileAssocObj]: files,
							},
						}));
					}}
					handleDelete={handleFileDelete}
					handleDownload={handleFileDownload}
				/>
				{/* add Images Modal */}

				{addNewImgModal && (
					<AddNewImageModal modalOpen={addNewImgModal} setModalOpen={setAddNewImgModal} submitFunction={addNewImages} />
				)}
				{imgInfoModal && (
					<EditImageDataModal modalOpen={imgInfoModal} setModalOpen={setImgInfoModal} submitFunction={updateMainImage} />
				)}
			</Box>
		);
	else {
		if (!Loadingopen)
			return (
				<Stack display="flex" justifyContent="center" alignItems="center" height="100%" spacing={1}>
					<Typography variant="h5" p={2}>
						---- No Profile Id Found ----
					</Typography>
					<Button variant="contained" sx={{ textTransform: "capitalize" }} onClick={goToProfilesPage}>
						Go to All Profiles
					</Button>
				</Stack>
			);
	}
};

export default SelectedModalProfile;
